// extracted by mini-css-extract-plugin
export var externalLink = "_9f-0";
export var internalLinkLabel = "_9f-1";